import NeptuneElement from '../../NeptuneElement.js';
import '../../core/button/Button.js';

class Modal extends NeptuneElement {

    static OPEN_VALUES = ['', 'true', 'false'];

    templateMarkup = `
    <dialog>
        <neptune-button id="closeButton" type="tertiary" size="small" icon-start="fa-close"></neptune-button>
        <h2>
            <slot name="header"></slot>
        </h2>
        <slot name="body"></slot>
        <slot name="footer"></slot>
    </dialog>
    `;

    componentCssUrl = '/src/components/container/modal/modal.css';

    dialog = null;
    closeButton = null;

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.dialog = this.shadowRoot.querySelector('dialog');
        this.closeButton = this.shadowRoot.querySelector('neptune-button');
        this.processInitialAttributesAfterRender(Modal.observedAttributes);
        this.setEventListeners();
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['open'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) {return;}
        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        if (name === 'open') {
            this.validatePropertyValue(name, newValue, Modal.OPEN_VALUES);
            if (!this.dialog) {return;}
            
            if (newValue === 'true' && !this.dialog.open) {
                this.dialog.showModal();
            } else if (newValue !== 'true' && this.dialog.open) {
                this.dialog.close();
            }
        }
    }

    setEventListeners() {
        this.dialog?.addEventListener('click', (e) => e.target === this.dialog && this.close());
        this.dialog?.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
        this.closeButton?.addEventListener('click', () => this.close());
    }

    removeEventListeners() {
        this.dialog?.removeEventListener('click', (e) => e.target === this.dialog && this.close());
        this.dialog?.removeEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
        this.closeButton?.removeEventListener('click', () => this.close());
    }

    open() {
        if (!this.dialog) {
            setTimeout(() => this.open(), 0);
            return;
        }
        this.setAttribute('open', 'true');
        this.dispatchEvent(new CustomEvent('neptune-modal-open', { bubbles: true, composed: true }));
    }

    close() {
        this.setAttribute('open', 'false');
        this.dispatchEvent(new CustomEvent('neptune-modal-close', { bubbles: true, composed: true }));
    }
}

customElements.define('neptune-modal', Modal);

export default Modal;